import React from 'react'
import './NotFound.css'

function NotFound() {
  return (
    <div className="home container">
    <div className="NotFound-div">
      <h1 className="NotFound-banner">404 NOT FOUND</h1>
      <h4>
        Sorry, there is no content here. Please use the navaigation above to get to where you were going.
      </h4>
    </div>
  </div>
  )
}

export default NotFound
